import { ORDER_CREATION_TIME_STATUS } from '../../../../business/order/geoqueue';
import { colorTheme } from '../theme.const';

export const turboCreationAtColor = {
  [ORDER_CREATION_TIME_STATUS.urgency]: colorTheme.turbo.danger,
  [ORDER_CREATION_TIME_STATUS.danger]: colorTheme.turbo.danger,
  [ORDER_CREATION_TIME_STATUS.warning]: colorTheme.turbo.warning,
};
